<template>
	<div>
		<!-- 面包屑导航区域 -->
		<el-breadcrumb separator="/">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item><span>系统管理</span></el-breadcrumb-item>
			<el-breadcrumb-item>员工管理</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<!-- 搜索与添加区域 -->
			<div class="search-area">
				<el-form ref="searchForm" :model="staffReq" label-width="70px" inline size="small">
					<el-form-item label="员工昵称:">
						<el-input :clearable="true" v-model="staffReq.nickName" placeholder="请输入员工昵称" style="width: 150px;" />
					</el-form-item>
					<el-form-item>
						<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="getStaffList()">查询</el-button>
					</el-form-item>
				</el-form>
			</div>
			<!-- 员工列表区 -->
			<el-table :data="staffList" border stripe :header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }">
				<el-table-column type="index"></el-table-column>
				<el-table-column label="员工昵称" prop="nickName"></el-table-column>
				<el-table-column label="手机号" prop="mobile"></el-table-column>
				<el-table-column label="运营商" prop="distributorId" v-if="isAdmin">
					<template slot-scope="scope">
						{{ getDistributorName(scope.row.distributorId) }}
					</template>
				</el-table-column>
				<el-table-column label="状态">
					<template slot-scope="scope">
						<el-switch v-model="scope.row.status" @change="staffStateChanged(scope.row)" active-color="#3CA757"></el-switch>
					</template>
				</el-table-column>
				<el-table-column label="备注" prop="remark"></el-table-column>
				<el-table-column label="创建时间" prop="createTime"></el-table-column>
				<el-table-column label="操作" width="200px">
					<template slot-scope="scope">
						<el-button style="background-color: #3CA757;color: #FFFFFF;" icon="el-icon-edit" size="mini"
							@click="editStaff(scope.row)">编辑</el-button>
						<el-button type="primary" icon="el-icon-s-grid" size="mini" style="margin-left: 8px;"
							@click="assignRoles(scope.row)">角色分配</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页区域 -->
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="staffReq.page" :page-sizes="[8, 15, 25, 50, 100]" :page-size="staffReq.limit"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
			<!-- 编辑员工对话框 -->
			<el-dialog title="编辑员工" :visible.sync="editDialogVisible" width="600px">
				<el-form :model="editStaffForm" status-icon ref="editStaffForm" label-width="100px" class="demo-ruleForm">
					<el-form-item label="员工昵称" prop="nickName">
						<el-input v-model="editStaffForm.nickName" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="手机号" prop="mobile">
						<el-input v-model="editStaffForm.mobile" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="运营商" prop="distributorId" v-if="isAdmin">
						<el-select v-model="editStaffForm.distributorId" placeholder="请选择运营商" size="small" 
							@change="handleDistributorChange" style="width: 100%;">
							<el-option v-for="item in distributorOptions" :key="item.key" :label="item.value" :value="item.key"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="备注" prop="remark">
						<el-input v-model="editStaffForm.remark" type="textarea" size="small" :clearable=true></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="editDialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="updateStaff()">确 定</el-button>
				</span>
			</el-dialog>
			<!-- 角色分配对话框 -->
		<el-dialog title="员工角色分配" :visible.sync="roleDialogVisible" width="500px">
			<el-form :model="roleForm" label-width="100px">
				<el-form-item>
					<el-radio-group v-model="selectedRole" style="width: 100%;">
						<el-radio v-for="role in roleList" :key="role.id" :label="role.id" style="width: 100%; margin: 10px 0;">
							{{ role.roleName }}
						</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="roleDialogVisible = false">取 消</el-button>
				<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="saveRoles()">保 存</el-button>
			</span>
		</el-dialog>
		</el-card>
	</div>
</template>

<script>
export default {
	data() {
		return {
			//是否是超级管理员
			isAdmin: false,
			staffReq: {
			//当前页数
			page: 1,
			//当前每页多少条
			limit: 8,
			nickName: '',
			distributorId: ''
		},
			staffList: [],
			total: 0,
			//控制编辑员工对话框显示与隐藏
			editDialogVisible: false,
			//编辑员工表单
			editStaffForm: {
				id: '',
				nickName: '',
				distributorId: '',
				distributorName: '',
				mobile: '',
				remark: ''
			},
			//运营商列表
			distributorOptions: [],
			//角色分配对话框
			roleDialogVisible: false,
			//当前操作的员工
	currentStaff: {},
		//角色分配表单
	roleForm: {},
			//角色列表数据
	roleList: [],
		selectedRole: ''
		}
	},
	created() {
		this.checkIsSuperAdmin()
		this.getStaffList()
		this.getDistributorList()
	},
	methods: {
		//检查是否是超级管理员
		checkIsSuperAdmin() {
		this.user = window.sessionStorage.getItem('user');
		this.isAdmin = window.sessionStorage.getItem('isAdmin') === 'true';
		},
		//根据运营商ID获取运营商名称
		getDistributorName(distributorId) {
			if (!distributorId) return '-'
			const distributor = this.distributorOptions.find(item => item.key === distributorId)
			return distributor ? distributor.value : '-'
		},
		async getStaffList() {
			const { data: res } = await this.$http.post(
				'/mini/operationMiniUser/getStaffPageInfo',
				this.staffReq)
				console.log('获取员工列表响应:', res)
			if (res.code != 200) return this.$message.error(res.msg)
			this.staffList = res.data.list
			this.total = res.data.total
		},
		//获取运营商列表
		getDistributorList() {
			this.$http.get('distributor/manager/getAllDistributorInfo').then((res) => {
				this.distributorOptions = [];
				if (res.data.code != 200) return this.$message.error(res.data.msg);
				let distributorInfoList = res.data.data;
				for (let index in distributorInfoList) {
					this.distributorOptions.push({ key: distributorInfoList[index].id, value: distributorInfoList[index].name });
				}
			});
		},
		//监听pagesize变化
		handleSizeChange(pageSize) {
			this.staffReq.limit = pageSize
			this.getStaffList()
		},
		//监听页数变化
		handleCurrentChange(pageNum) {
			this.staffReq.page = pageNum
			this.getStaffList()
		},
		//员工状态变更
		staffStateChanged(staff) {
			this.$http.post('/mini/operationMiniUser/updateStatus', {
				id: staff.id,
				status: staff.status,
			}).then((res) => {
				if (res.data.code == 200) {
						this.$message.success(staff.status ? '已开启' : '已禁用')
					} else {
						this.$message.error('状态更新失败')
						// 恢复原状态
						staff.status = !staff.status
					}
			})
		},
		//编辑员工
		editStaff(staff) {
			this.editStaffForm = {
				id: staff.id,
				nickName: staff.nickName,
				distributorId: staff.distributorId,
				distributorName: staff.distributorName,
				mobile: staff.mobile || '',
				remark: staff.remark
			}
			this.editDialogVisible = true
		},
		//处理运营商选择变化
		handleDistributorChange(distributorId) {
			const selectedDistributor = this.distributorOptions.find(item => item.key === distributorId)
			if (selectedDistributor) {
				this.editStaffForm.distributorName = selectedDistributor.value
			}
		},
		//更新员工
		async updateStaff() {
			const { data: res } = await this.$http.post(
				'/mini/operationMiniUser/updateStaff',
				this.editStaffForm)
			if (res.code != 200) return this.$message.error(res.msg)
			this.$message.success('更新成功')
			this.editDialogVisible = false
			this.getStaffList()
		},
		//删除员工
		deleteStaff(id) {
			this.$confirm("确认删除该员工吗？", {
				title: "提示",
				type: 'warning',
			}).then(resc => {
				this.$http.get('mini/operationMiniUser/deleteById/' + id).then(res => {
					if (res.data.code == 200) {
						this.getStaffList()
						this.$message.success('删除成功')
					} else {
						this.$message.error('删除失败')
					}
				})
			})
		},
		//角色分配
		async assignRoles(staff) {
			this.currentStaff = staff
			this.roleDialogVisible = true
			// 调用角色列表接口
			const { data: res } = await this.$http.get('/api/permission/role/list')
			if (res.code != 200) return this.$message.error(res.message)
			this.roleList = res.data
			// 调用员工已有角色接口
			const { data: roleRes } = await this.$http.get(`/api/permission/staff-role/${staff.openId}`)
			if (roleRes.code != 200) return this.$message.error(roleRes.message)
			// 初始化选中的角色（取第一个角色）
			const roleIds = roleRes.data.roleIds || []
			this.selectedRole = roleIds.length > 0 ? roleIds[0] : ''
		},

		//保存角色
		async saveRoles() {
			if (!this.selectedRole) {
				return this.$message.warning('请选择角色')
			}
			const { data: res } = await this.$http.post(
				'/api/permission/staff-role',
				{
					openId: this.currentStaff.openId,
					roleIds: [this.selectedRole]
				})
			if (res.code != 200) return this.$message.error(res.message)
			this.$message.success('角色分配成功')
			this.roleDialogVisible = false
		}
	},
}
</script>

<style>
.search-area {
	margin-bottom: 20px;
}

.el-checkbox__input.is-checked+.el-checkbox__label {
    color: #606266 !important;
}
</style>
